<div class="chart-setup">
  <form [formGroup]="form">
    <div class="chart-setup__summary-type-row">
      <div class="flex flex-col gt-xs:flex-row w-full">
        <mat-form-field class="flex-auto gt-xs:pr-3">
          <mat-label>Chart Type</mat-label>
          <mat-select formControlName="chart_type">
            <mat-option value="line">Line</mat-option>
            <mat-option value="bar">Bar</mat-option>
            <ng-container *ngIf="!isTimeSeries">
              <mat-option value="horizontal-bar">Horizontal Bar</mat-option>
              <mat-option value="donut">Donut</mat-option>
              <mat-option value="metric">Metric</mat-option>
              <mat-option value="table" *ngIf="hasTableVisualizationEnabled$ | async">Table</mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
      @if (isChartTypeTable) {
        <div class="flex flex-col gt-xs:flex-row w-full">
          <mat-form-field class="flex-auto gt-xs:pr-3">
            <mat-label>Display Fields</mat-label>
            <mat-select multiple formControlName="display_fields">
              <mat-option *ngFor="let field of fields" [value]="field.name">
                {{ field.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      } @else {
        <div class="flex flex-col gt-xs:flex-row w-full">
          <mat-form-field class="flex-auto gt-xs:pr-3">
            <mat-label>Summary Type</mat-label>
            <mat-select formControlName="summary_type">
              <mat-option *ngIf="isTimeSeries && isChartTypeLine" value="none">None</mat-option>
              <mat-option value="total">Count</mat-option>
              <mat-option value="sum">Sum</mat-option>
              <mat-option *ngIf="isChartTypeLine || isChartTypeVerticalBar || isChartTypeMetric" value="average"
                >Average</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      }
    </div>
    <div class="flex flex-col gt-xs:flex-row" *ngIf="!isTimeSeries && showSummaryField">
      <mat-form-field class="flex-auto gt-xs:pr-3">
        <mat-label>Summary Field</mat-label>
        <mat-select *ngIf="!allowRelatedObjectFields; else groupedFieldsSummary" formControlName="summary_value">
          <mat-option *ngFor="let field of fields" [value]="field.name">{{ field.label }} </mat-option>
        </mat-select>
        <ng-template #groupedFieldsSummary>
          <mat-select formControlName="summary_value">
            <mat-optgroup
              *ngFor="let group of fields | groupBy: 'related_to_type' : 'label'"
              [label]="group.groupName | relatedToTypeTitle: []"
              [disabled]="false"
            >
              <mat-option *ngFor="let item of group.items" [value]="item.name">
                {{ item.label }}
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </ng-template>
      </mat-form-field>
    </div>
    <div class="chart-setup__x-axis-series-row" *ngIf="showXAxisAndSeries">
      <div class="flex flex-col gt-xs:flex-row w-full">
        <mat-form-field class="flex-auto gt-xs:pr-3">
          <mat-label>X-Axis</mat-label>
          <mat-select *ngIf="!allowRelatedObjectFields; else groupedFieldsGroupBy" formControlName="group_by">
            <mat-option *ngFor="let field of fields | filterBy: [''] : seriesValue : filterGroupBy" [value]="field.name"
              >{{ field.label }}
            </mat-option>
          </mat-select>
          <ng-template #groupedFieldsGroupBy>
            <mat-select formControlName="group_by">
              <mat-optgroup
                *ngFor="
                  let group of fields
                    | filterBy: [''] : seriesValue : filterGroupBy
                    | groupBy: 'related_to_type' : 'label'
                "
                [label]="group.groupName | relatedToTypeTitle: []"
                [disabled]="false"
              >
                <mat-option *ngFor="let item of group.items" [value]="item.name">
                  {{ item.label }}
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </ng-template>
        </mat-form-field>
      </div>
      <div class="flex flex-col gt-xs:flex-row w-full" *ngIf="!isChartTypeDonut">
        <mat-form-field class="flex-auto gt-xs:pr-3">
          <mat-label>Group By</mat-label>
          <mat-select *ngIf="!allowRelatedObjectFields; else groupedFieldsSeries" formControlName="series_value">
            <mat-option [value]=""></mat-option>
            <mat-option
              *ngFor="let field of fields | filterBy: [''] : groupByValue : filterSeriesValue"
              [value]="field.name"
              >{{ field.label }}
            </mat-option>
          </mat-select>
          <ng-template #groupedFieldsSeries>
            <mat-select formControlName="series_value">
              <mat-optgroup
                *ngFor="
                  let group of fields
                    | filterBy: [''] : groupByValue : filterSeriesValue
                    | groupBy: 'related_to_type' : 'label'
                "
                [label]="group.groupName | relatedToTypeTitle: []"
                [disabled]="false"
              >
                <mat-option *ngFor="let item of group.items" [value]="item.name">
                  {{ item.label }}
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </ng-template>
        </mat-form-field>
      </div>
    </div>
  </form>
  <div class="chart-setup__actions">
    <button mat-flat-button color="primary" (click)="create()" [disabled]="!form.valid">
      {{ visualization ? 'Save' : 'Create' }}
    </button>
    <button mat-flat-button (click)="cancel()">Cancel</button>
  </div>
</div>
